<template>
  <div v-if="visible" class="consent-banner">
    <div class="consent-content">
      <div class="consent-text">
        <h3 class="consent-title">🍪 Cookies</h3>
        <p>Nous utilisons des cookies pour améliorer votre expérience. Acceptez-vous le suivi via Google Analytics ?</p>
      </div>
      <div class="consent-controls">
        <div class="checkbox-container">
          <Checkbox v-model="analyticsConsent" :binary="true" inputId="analyticsConsentCheckbox" />
          <label for="analyticsConsentCheckbox">Google Analytics</label>
        </div>
        <div class="button-group">
          <Button label="Refuser" @click="refuseConsent" class="p-button-text" />
          <Button label="Accepter" @click="acceptConsent" class="p-button-success" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import Button from 'primevue/button';
import Checkbox from 'primevue/checkbox';

const analyticsConsent = ref(false);
const visible = ref(false);

onMounted(() => {
  const consent = localStorage.getItem('analytics_consent');
  if (!consent) {
    visible.value = true;
    setDefaultConsentState();
  }
});

const setDefaultConsentState = () => {
  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function() { window.dataLayer.push(arguments); };
  window.gtag('consent', 'default', {
    'ad_storage': 'denied',
    'ad_user_data': 'denied',
    'ad_personalization': 'denied',
    'analytics_storage': 'denied',
  });
};

const acceptConsent = () => {
  localStorage.setItem('analytics_consent', JSON.stringify(true));
  localStorage.setItem('ga4_enabled', JSON.stringify(analyticsConsent.value));
  visible.value = false;

  window.gtag('consent', 'update', {
    'ad_storage': analyticsConsent.value ? 'granted' : 'denied',
    'ad_user_data': analyticsConsent.value ? 'granted' : 'denied',
    'ad_personalization': analyticsConsent.value ? 'granted' : 'denied',
    'analytics_storage': analyticsConsent.value ? 'granted' : 'denied',
  });

  if (analyticsConsent.value) {
    initializeGA4();
  }
};

const refuseConsent = () => {
  localStorage.setItem('analytics_consent', JSON.stringify(false));
  localStorage.setItem('ga4_enabled', JSON.stringify(false));
  visible.value = false;

  window.gtag('consent', 'update', {
    'ad_storage': 'denied',
    'ad_user_data': 'denied',
    'ad_personalization': 'denied',
    'analytics_storage': 'denied',
  });
};

const initializeGA4 = () => {
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://www.googletagmanager.com/gtag/js?id=G-07WV4QD1R0';
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag('js', new Date());
  window.gtag('config', 'G-07WV4QD1R0');
};
</script>

<style scoped>
.consent-banner {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: white;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  padding: 0.75rem 1.5rem;
  z-index: 1000;
}

.consent-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 2rem;
}

.consent-text {
  flex: 1;
}

.consent-title {
  font-size: 1rem;
  margin: 0 0 0.5rem 0;
  font-weight: 600;
}

.consent-text p {
  margin: 0;
  font-size: 0.9rem;
  color: #666;
}

.consent-controls {
  display: flex;
  align-items: center;
  gap: 1.5rem;
}

.checkbox-container {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.checkbox-container label {
  font-size: 0.9rem;
  color: #666;
}

.button-group {
  display: flex;
  gap: 0.5rem;
}

@media (max-width: 768px) {
  .consent-content {
    flex-direction: column;
    gap: 1rem;
  }
  
  .consent-controls {
    width: 100%;
    flex-direction: column;
    align-items: stretch;
  }
  
  .button-group {
    justify-content: stretch;
  }
  
  .button-group button {
    flex: 1;
  }
}
</style>